import React from 'react';

import { createClassName } from 'utils/createClassName';

import './partnerCodeFieldStyles.scss';

type Props = {
  label: React.ReactNode;
  input: React.ReactNode;
};

export const PartnerCodeFieldComponent: React.FC<Props> = (props) => {
  const { label, input } = props;

  const createPartnerCodeField = createClassName('partnerCodeField');

  const wrapperClassName = createPartnerCodeField('wrapper');

  const labelClassName = createPartnerCodeField('label');

  const inputClassName = createPartnerCodeField('input');

  return (
    <div className={wrapperClassName}>
      <div className={labelClassName}>{label}</div>
      <div className={inputClassName}>{input}</div>
    </div>
  );
};
